import {useRef} from "react";
const ParamRow = ({field, index, item, fieldsValidated}) => {
    const def = item.parameters.payload[index];
    const validation = fieldsValidated.current[index] || {valid: true};
    const invalid = validation?.valid === false;
    const decimalDisplay = useRef("");

    if (def && (def.type === "bytes" || field.type === "bytes")) {
        if (field.name === "código") {
            decimalDisplay.current = "";
        } else {
            decimalDisplay.current = parseInt(field.raw, 16) ?? "";
        }
    }

    return (
        <tr>
            <td className="text-center align-middle">{field.name}</td>
            <td className="w-auto text-end align-middle">
                <input
                    className={`form-control form-control-sm text-end ${invalid ? "is-invalid border-danger" : ""}`}
                    style={{width: "80px"}}
                    readOnly
                    value={field.raw}
                />
                {invalid ? <small className="text-danger d-block">{validation.reason || "Valor no válido"}</small> : null}
            </td>
            <td className="text-center align-middle">{decimalDisplay.current}</td>
            <td className="text-center align-middle">{field.length}</td>
            <td className="px-1 align-middle">{field.description}</td>
        </tr>
    );
};

export default ParamRow;
